import {
	IItemBasicPrimaryField,
	LuSelectItemBasicOptions
} from './lu-select-items/lu-select-item-basic/lu-select-item-basic.component';
import { LuSelectOptions } from './lu-select.models';

export class LuSelectBuilder {
	static buildBasic(
		field: string,
		selectAs: string,
		placeholder?: string,
		displayClearButton?: boolean
	): LuSelectOptions {
		// NOTE: Remove placeholder as part of DEV-8485

		const selectPrimaryField: IItemBasicPrimaryField = {
			field: field
		};
		const selectItemOptions = new LuSelectItemBasicOptions(selectPrimaryField);

		const options: LuSelectOptions = {
			displayClearButton,
			itemOptions: selectItemOptions,
			selectAs: selectAs,
			placeholder: placeholder || null, // Remove placeholder as part of DEV-8485
			paginate: false
		};
		return options;
	}
}
